module.exports = __webpack_public_path__ + "img/preview.d95ee6db.svg";